// extracted by mini-css-extract-plugin
export default {"table":"CompaniesTable_table__jcUfT"};